export default __webpack_public_path__ + "static/media/dark-photo.943b7d1d.png";